var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 4",
    d: "M2 9.16663C4.4 3.83329 11.6 3.83329 14 9.16663",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 11.8334C6.89543 11.8334 6 10.9379 6 9.83337C6 8.7288 6.89543 7.83337 8 7.83337C9.10457 7.83337 10 8.7288 10 9.83337C10 10.9379 9.10457 11.8334 8 11.8334Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeAlt);
export default __webpack_public_path__ + "static/media/eye-alt.18fb8b86915d4f37f3b673fd5a2e4582.svg";
export { ForwardRef as ReactComponent };